module.exports = __webpack_public_path__ + "static/61import-20fb877ad0c18fd34276884e8cba5354.png";